import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export const MOODS = [
  "المخرج يختار الأنسب",
  "فاخر وهادئ",
  "دافئ وعائلي",
  "منعش وحيوي",
  "ليلي أنيق",
  "طبيعي نهاري",
  "عصري وشبابي",
  "تراثي سعودي أصيل",
  "رمضاني سعودي (فوانيس وهلال ومجلس إفطار)",
  "عيد الفطر سعودي (فرحة العيد والحلويات والعيديات)",
  "عيد الأضحى سعودي (كرم العائلة وولائم العيد)",
  "موسم الحج (أجواء روحانية باحترام)",
  "اليوم الوطني السعودي (أخضر وعلم وفخر)",
  "يوم التأسيس (الدرعية وزي التأسيس)",
  "احتفالي سعودي عام",
];

// Appends the chosen mood to a prompt (comma, not a dash — a dash would be read as a script direction).
export const withMood = (text, mood) => (mood && !mood.startsWith("المخرج") ? `${text}، الأجواء المطلوبة: ${mood}` : text);

export const MoodSelect = ({ value, onChange, testId, label = "الأجواء المطلوبة" }) => (
  <div>
    <Label className="mb-2 block">{label} <span className="text-red-400">*</span></Label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="bg-secondary border-border" data-testid={testId}><SelectValue placeholder="اختر الأجواء" /></SelectTrigger>
      <SelectContent className="bg-popover border-border">
        {MOODS.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);
